import { get as getDeepValue } from 'react-hook-form'

export const errorsToMuiProps = (errors, field) => {
    const errorValue = getDeepValue(errors, field)
    if (!errorValue) {
        return null
    }

    const helperText = typeof errorValue === 'string' ? errorValue : errorValue.message

    return { error: true, helperText }
}

export function flattenFrontendErrors(frontend) {
    const errors = {}

     
    for (const [field, value] of Object.entries(frontend || {})) {
        if (value?.message && value?.message.length) {
            errors[field] = value?.message
        } else if (value?.type === 'required') {
            errors[field] = 'This field is required.'
        } else if (value?.type === 'max') {
            errors[field] = 'Value exceeds the maximum allowed value.'
        } else if (value?.type === 'min') {
            errors[field] = 'Value is below the minimum allowed value. '
        } else if (typeof value === 'object') {
            errors[field] = flattenFrontendErrors(value)
        }
    }

    return errors
}

export function flattenBackendErrors(backend) {
    const errors = {}

     
    for (const [field, value] of Object.entries(backend || {})) {
        if (Array.isArray(value)) {
             
            errors[field] = value[0]
        } else if (typeof value === 'object') {
            errors[field] = flattenBackendErrors(value)
        } else {
            errors[field] = String(value)
        }
    }

    return errors
}

export function mergeErrors(frontend, backend) {
    // Frontend validation only returns type=required, and backend validation returns a full array of errors
    // So we convert these to a simple {field: error, ...} dictionary
    return { ...flattenFrontendErrors(frontend), ...flattenBackendErrors(backend) }
}
